import * as Yup from "yup";

import { DutyScheduleFormValues } from "@/pages/duty-schedule/DutySchedule.types";
import { ITranslation } from "@/translations";

export function emptyDutyScheduleFormValues(): DutyScheduleFormValues {
  return { name: "", periodStart: null, periodEnd: null };
}

export function dutyScheduleValidationSchema(t: ITranslation) {
  return Yup.object().shape<{ [P in keyof DutyScheduleFormValues]?: Yup.AnySchema }>({
    name: Yup.string().required(t("common.validation.fieldRequired", { fieldName: t("dutySchedule.create.name") })),
    periodStart: Yup.date()
      .nullable()
      .typeError(t("common.validation.invalidDateFormat"))
      .required(t("common.validation.fieldRequired", { fieldName: t("dutySchedule.create.periodStart") })),
    periodEnd: Yup.date()
      .nullable()
      .typeError(t("common.validation.invalidDateFormat"))
      .required(t("common.validation.fieldRequired", { fieldName: t("dutySchedule.create.periodEnd") }))
      .test("after-start", t("dutySchedule.create.validation.periodEndAfterStart"), function () {
        const { periodStart, periodEnd } = this.parent as DutyScheduleFormValues;
        if (periodStart == null || periodEnd == null) {
          return true;
        }
        return periodEnd > periodStart;
      }),
  });
}
